import cn from "classnames";
import { Loader } from "../../../loader";
import { TableProps } from "./types";
import styles from "./styles.module.scss";

export const Table = ({
  children,
  isLoading,
  footer,
  infiniteScroll,
  className,
  dataTestId = "table",
  ...restProps
}: TableProps) => (
  <div className={cn(styles.wrapper, className)} data-test-id={dataTestId}>
    {isLoading ? (
      <Loader className={styles.loader} dataTestId={`${dataTestId}-loader`} />
    ) : (
      <table className={styles.table} {...restProps}>
        {children}
      </table>
    )}
    {infiniteScroll}
    {footer}
  </div>
);
